import React, { useContext } from 'react';
import classnames from 'classnames';
import get from 'lodash/get';
import { PopperDropdownToggle } from '../../../PopperDropdownLayout';
import { DropdownStateContext } from '../../../DropdownStateManager';
import ArrowDownIcon from '../../../../Icons/ArrowDown';
import s from './StandardDropdownToggle.scss';
var StandardDropdownToggle = function (_a) {
    var dropdownId = _a.dropdownId, selectedItem = _a.selectedItem, placeholder = _a.placeholder, placeholderClassName = _a.placeholderClassName, toggleClassName = _a.toggleClassName, openClassName = _a.openClassName, arrowClassName = _a.arrowClassName, arrowSize = _a.arrowSize, renderArrowDown = _a.renderArrowDown, ariaLabel = _a["aria-label"], ariaHasPopup = _a["aria-haspopup"], tabIndex = _a.tabIndex;
    var isOpen = useContext(DropdownStateContext).isOpen;
    var selectedLabel = get(selectedItem, 'label');
    return (React.createElement(PopperDropdownToggle, { className: classnames(s['toggle'], toggleClassName, !selectedLabel && placeholderClassName, isOpen && openClassName), "aria-label": ariaLabel, "aria-expanded": isOpen, "aria-controls": dropdownId, "aria-haspopup": ariaHasPopup, tabIndex: tabIndex },
        get(selectedItem, 'icon', ''),
        " ",
        selectedLabel || placeholder,
        ' ',
        renderArrowDown ? (renderArrowDown(classnames(s['arrow-icon'], arrowClassName, isOpen && s['is-open']))) : (React.createElement(ArrowDownIcon, { className: classnames(s['arrow-icon'], arrowClassName, isOpen && s['is-open']), size: arrowSize }))));
};
StandardDropdownToggle.displayName = 'StandardDropdownToggle';
export default StandardDropdownToggle;
//# sourceMappingURL=StandardDropdownToggle.js.map